'use client'

import { Breakpoints } from 'fukku/styles/breakpoints'
import type { PointOfInterestImage } from 'landings/Home/Home.type'
import { pointOfInterestImageLoaderFactory } from 'landings/utils/pointOfInterestImageLoaderFactory'
import Image from 'next/image'
import { CapsuleBannerType } from 'services/graphql/contentStack/homes/query.type'
import { getPointOfInterest } from '../../../utils/getPointOfInterest/getPointOfInterest'

type LineBannerImageProps = {
	readonly image: PointOfInterestImage
	readonly type: CapsuleBannerType
	readonly priority?: boolean
}

const ASPECT_RATIO_MOMENTS_SMALL_WIDTH = 5
const ASPECT_RATIO_MOMENTS_SMALL_HEIGHT = 7
const ASPECT_RATIO_MOMENTS_SMALL =
	ASPECT_RATIO_MOMENTS_SMALL_WIDTH / ASPECT_RATIO_MOMENTS_SMALL_HEIGHT

const ASPECT_RATIO_FULLHEIGHT_WIDTH = 7
const ASPECT_RATIO_FULLHEIGHT_HEIGHT = 3

const ASPECT_RATIO_FULLHEIGHT =
	ASPECT_RATIO_FULLHEIGHT_WIDTH / ASPECT_RATIO_FULLHEIGHT_HEIGHT

export function CapsuleBannerImage({
	image,
	type,
	priority = false,
}: LineBannerImageProps) {
	const capsuleBannerImageLoader = pointOfInterestImageLoaderFactory(
		getPointOfInterest({ image }),
		(width) => {
			if (type === CapsuleBannerType.Moments && width <= Breakpoints.medium) {
				return width / ASPECT_RATIO_MOMENTS_SMALL
			}
			return width / ASPECT_RATIO_FULLHEIGHT
		}
	)

	return (
		<Image
			fill
			alt={image.description ?? ''}
			priority={priority}
			src={image.url}
			style={{
				objectFit: 'cover',
			}}
			loader={capsuleBannerImageLoader}
			sizes={'100vw'}
			draggable={false}
		/>
	)
}
